import { clearStoredSession } from "./currentUser";
import { disconnectSocket } from "./socket";

// #87 / SEC-085: the ONE way a session ends in this app. Every logout,
// forced logout, 401 handler and blocked/deleted-account redirect calls
// this instead of deleting the `currentUser` key from localStorage itself.
// (Do not write that removeItem call out literally in a comment here: the
// source guard in production-patterns.test.js would match it.)
//
// The socket goes first: once storage is cleared the socket's auth callback
// would hand out no token, but an already-open connection stays
// authenticated as the user who just left until it is closed.
//
// Kept separate from clearStoredSession() (currentUser.js), which stays
// storage-only: socket.js imports currentUser.js, so the reverse import
// would be a cycle. tests/helpers/production-patterns.test.js enforces
// that nothing else removes `currentUser`.
export function clearSession() {
  disconnectSocket();
  clearStoredSession();
}
